export default "/assets/website/images/info-icon.svg?56c450927ba5315eb588bf128dd75e0c";